import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Form from './Form'

export default function SchoolAccessFormIndex({ type }) {
  const { id } = useParams()
  const item = useSelector(state =>
    id === 'new' ? null : state.settings.serviceAccess.list?.find(i => i.id === Number(id))
  )

  return <Form item={item} activeType={type} />
}
